import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ToastService } from 'angular-toastify';
import { ApiService } from '../../../../../core/services/api.service';
import { AddLineMemberCustomerPayload, CityParkingCustomerInfoResponse, CityParkingCustomerLinesResponse, CityParkingLineListForChooseResponse } from '../../../../../core/models/customer.model';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-modal-customer-add',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './modal-customer-add.component.html',
  styleUrls: ['./modal-customer-add.component.css']
})
export class ModalCustomerAddComponent implements OnInit {

  @Input() customer: CityParkingCustomerInfoResponse | null = null;
  @Output() close = new EventEmitter<boolean>();
  @Output() save = new EventEmitter<boolean>();

  lineData: AddLineMemberCustomerPayload = {
    cpCustomerId: 0,
    cpUserId: 0,
    userId: 0,
  };
  name: string = '';
  keyword: string = '';
  lineChoose: CityParkingLineListForChooseResponse[] = [];
  selectedMember: CityParkingLineListForChooseResponse | null = null;
  isSearching: boolean = false;

  userId: number = 0;
  constructor(
    private apiService: ApiService,
    private toast: ToastService,
    private cookieService: CookieService,
  ) { }

  ngOnInit(): void {
    this.lineData.cpUserId = this.customer?.id || 0;
    this.name = this.customer?.name || '';

    const userIdFromSession = sessionStorage.getItem('user_id');
    this.userId = parseInt(this.cookieService.get('user_id')) || (userIdFromSession ? JSON.parse(userIdFromSession) : 0);
  }

  saveData() {
    if (!this.keyword) {
      this.toast.error('กรุณาระบุคำค้นหา');
      return;
    }

    // Call API Search
    this.getCityParkingCustomerLines();
  }

  selectMember(member: CityParkingLineListForChooseResponse) {
    this.selectedMember = member;
  }

  confirmAddMember() {
    if (!this.selectedMember) {
      this.toast.error('กรุณาเลือกสมาชิก');
      return;
    }

    this.lineData.cpCustomerId = this.customer?.id || 0;
    this.lineData.cpUserId = this.selectedMember.id;
    this.lineData.userId = this.userId;
    this.sentApiAddMember();
  }

  resetForm() {
    this.lineData = {
      cpCustomerId: 0,
      cpUserId: 0,
      userId: 0,
    };
    this.name = '';
    this.keyword = '';
    this.lineChoose = [];
    this.selectedMember = null;
    this.isSearching = false;
  }

  cancelSelection() {
    this.lineChoose = [];
    this.selectedMember = null;
    this.isSearching = false;
    // this.keyword = ''; // Optionally keep keyword?
  }
  closeModal() {
    this.close.emit(true);
  }

  /* ------------------------------------------------------ API ------------------------------------------------------ */

  getCityParkingCustomerLines() {
    this.isSearching = true;
    this.apiService.getCityParkingCustomerLines(this.keyword).subscribe({
      next: (res) => {
        this.isSearching = false;
        //console.log("CityParkingCustomerLines : ", res)
        if (res.length > 0) {
          this.lineChoose = res;
        } else {
          this.toast.error('ไม่พบข้อมูล');
          this.lineChoose = [];
        }
      },
      error: (err) => {
        this.isSearching = false;
        console.error(err);
        this.toast.error('เกิดข้อผิดพลาดในการเชื่อมต่อ');
        this.lineChoose = [];
      }
    });
  }

  sentApiAddMember() {
    this.apiService.AddLineMemberCustomer(this.lineData).subscribe({
      next: (res) => {
        //console.log("AddLineMemberCustomer : ", res)
        if (res.isSuccess) {
          this.toast.success('เพิ่มสมาชิกไลน์เรียบร้อย');
          this.save.emit();
          // this.closeModal();
        } else {
          this.toast.error(res.message || 'เกิดข้อผิดพลาด');
        }
      },
      error: (err) => {
        console.error(err);
        this.toast.error('เกิดข้อผิดพลาดในการเชื่อมต่อ');
      }
    });
  }

}
